import { render, staticRenderFns } from "./FormHeader.vue?vue&type=template&id=d0c9aea6&"
import script from "./FormHeader.vue?vue&type=script&lang=ts&"
export * from "./FormHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0c9aea6')) {
      api.createRecord('d0c9aea6', component.options)
    } else {
      api.reload('d0c9aea6', component.options)
    }
    module.hot.accept("./FormHeader.vue?vue&type=template&id=d0c9aea6&", function () {
      api.rerender('d0c9aea6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StockAdjustment/FormHeader.vue"
export default component.exports